<!-- 首页 -->
<template>
  <div class="wrap">
    <div class="indexbox">
      <div class="bar">
        <div class="head">
          <div class="logo">
            <img
              src="../assets/images/logo.png"
              class="el_logo"
              style="display: block; margin: 0 auto"
              alt=""
            />
          </div>
          <!-- <div id="shez_b01" @click="showa()" class="shez">
            <button
              type="button"
              class="wj-but"
              style="border: 1px solid #f198a7; display: block;text-align: center;"
            >设置</button>
          </div> -->
        </div>
        <div class="bi_middle">
          <div class="biaot">
            <img src="../assets/images/biaoti.png" alt="" />
          </div>

          <div class="user2" ref="card" @mouseleave="leave(index)" @mousemove="move(index)" v-for="(item, index) in pageData" :key="index" @click="urlgo(item.url,item.stateid,item.id,item.title)">
            <div class="user_tp">
              <!-- <i class="iconboxicon iconfont" :class="item.icon"></i> -->
              <img :src="'../../static/images/' + item.icon" alt="" />
            </div>
            <div class="texs">{{item.title}}</div>
            <div class="texs2">
              {{item.describe}}
            </div>
            <div class="hide_bj">
              <!-- <i class="iconboxicon iconfont" :class="item.icon"></i> -->
              <img :src="'../../static/images/' + item.stateid" alt="" />
            </div>
          </div>
        </div>
        <!-- <div v-if="shez_tc" class="shez_tk"> -->
        <div  class="shez_tk">
          <!-- <div id="close_01" @click="hideb" class="gb_code">
            <img src="../assets/images/gb.png" alt="" />
          </div> -->
          <div id="close_01" @click="hideb" class="gb_code">
            <!-- <img src="../assets/images/gb.png" alt="" /> -->
              <img @click="nowinvest" class="imgtanc" src="../assets/images/recharge.png" alt="">
              <img @click="chaxun"  class="imgtanc divimg" src="../assets/images/querycz.png" alt="">
              <img @click="Integral" class="imgtanc divimg" src="../assets/images/pointsdeta.png" alt="">
              <img @click="Feedback" class="imgtanc divimg" src="../assets/images/feedback.png" alt="">
          </div>
          <div class="content_box">
            <div class="organ">
              <span>当前机构：</span>
              {{shopname}}
              <!-- <hr class="hr_fg" color="linen" /> -->
            </div>
            <div class="username">
              <span>姓名：</span>
              {{username}}
              <!-- <hr class="hr_fg" color="linen" /> -->
            </div>
            <div class="number">
              <span>账号：</span>
              {{userno}}
              <!-- <hr class="hr_fg" color="linen" /> -->
            </div>
            <div class="cell-phone">
              <span>手机号：</span>
              {{mobiphone}}
              <!-- <hr class="hr_fg" color="linen" /> -->
            </div>
            <!-- <div class="cell-phone">
              <span>用户角色：</span>
              {{mobiphone}}
            </div>
            <div class="cell-phone">
              <span>是否区经：</span>
              {{mobiphone}}
            </div> -->
            <div class="network">
              <span>网速状态：</span>
              <!-- <span class="hq_wl">获取网速</span> -->
              <span v-loading="isture">{{getSpeed}}</span> 
              <!-- <hr class="hr_fg" color="linen" /> -->
            </div>
            <div class="jifenwb">
                <!-- <div class="xinxinwb"> -->
                <img class="xinxin" src="../assets/images/tinyspot.png" alt="">
                <!-- </div> -->
                <div>总积分：0</div>
                <div class="available">可用积分：0</div>
            </div>
            <div class="button_tc">
              <button
                id="button_jg"
                type="button"
                class="qh-but"
                @click="XZDialogVisible=true"
              >
                <span>切换机构</span>
              </button>
              <button type="button" @click="outusers" class="zx-but">
                <span>退出登录</span>
              </button>
            </div>
          </div>
          <div  class="content_box"  style="margin-top: 60px;">
            <div class="organ" style="margin-left:40px;">
              <span>智慧运维，答您所问</span>
            </div>
            <img src="../assets/腾讯元器小程序.png" style="margin-left:1px;width: 60%;" />
          </div>
        </div>
        
        <!-- 充值查询列表 -->
        <div v-if="Rechquery" class="shez">
           <div class="chargequ">
              <div class="jianjwb">
                <img src="../assets/images/jianja.png" alt="">
              </div>
              <div class="imggubiwb" @click="outguanb">
                <img src="../assets/images/imggubi.png" alt="">
              </div>
              <div class="titlewb">
                <div class="titleb">充值记录</div>
                <div class="xiabia"></div>
              </div>
              <el-row>
              <!-- <el-col class="biaogewb" :span="23" style="border: 1px solid #eaeaea"> -->
                <el-col class="biaogewb" :span="23" >
                  <div class="zkxs_table_box"
                   >
                    <!-- <el-table 
                      :data="gridData"
                      stripe
                      style="width: 100%"
                      size="mini"
                      v-loading="zkxs_loading"
                      class="titlebj"
                    > -->
                    <el-table 
                      :data="gridData"
                      size="mini"
                      class="titlebj"
                      :header-cell-style="{background:'#f5f7f8',color:'#333333'}"
                      :row-style="{ height: '56px' }"
                    >
                      <el-table-column
                        prop="orderno"
                        label="订单号"
                      ></el-table-column>
                      <el-table-column
                        prop="topuptime"
                        label="充值时间"
                        width="180"
                      ></el-table-column>
                      <el-table-column prop="topupname" label="充值名称"></el-table-column>
                      <el-table-column prop="topupmoney" width="120" label="充值金额"></el-table-column>
                      <el-table-column
                        prop="topupperson"
                        label="充值人"
                      ></el-table-column>
                      <el-table-column
                        prop="maturitytime"
                        label="机构到期日期"
                      ></el-table-column>
                      <el-table-column
                        prop="statename"
                        label="充值状态"
                      ></el-table-column>
                    </el-table>
                  </div>
                </el-col>
            </el-row>
           </div>
        </div>
        <!-- 积分明细 -->
        <div v-if="integrall" class="shez">
            <div class="ointails">
              <div class="jianjwb">
                <img src="../assets/images/jianja.png" alt="">
              </div>
              <div class="imggubiwb" @click="Pointsdetails">
                <img src="../assets/images/imggubi.png" alt="">
              </div>
              <div class="titlewb">
                <div class="titleb">积分明细</div>
                <div class="xiabia"></div>
              </div>
              <div class="box_kuang box_left">
                  <div class="wbtnb">
                      <el-select class="salesInput" size="mini" v-model="dalei_val" clearable placeholder="积分事项">
                        <el-option
                          v-for="item in dalei_item"
                          :key="item.rowid"
                          :label="item.taname"
                          :value="item.rowid"
                        ></el-option>
                      </el-select>
                  </div>
                  <div class="datatime">
                    <el-date-picker
                      size="mini"
                      v-model="saledate_val"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="~"
                      style="width:300px;"
                      start-placeholder="积分日期"
                    ></el-date-picker> 
                  </div>
                  <el-button
                    class="iconanniu"
                    size="mini"
                    type="primary"
                    :loading="queryloading"
                    @click="SaleListGet(1)"
                    >查询</el-button
                  >
              </div>
              <el-row>
              <!-- <el-col class="biaogewb" :span="23" style="border: 1px solid #eaeaea"> -->
                <el-col class="biaogewb" :span="23" >
                  <div class="zkxs_table_box"
                   >
                    <!-- <el-table 
                      :data="gridData"
                      stripe
                      style="width: 100%"
                      size="mini"
                      v-loading="zkxs_loading"
                      class="titlebj"
                    > -->
                    <el-table 
                      :data="gridData"
                      size="mini"
                      class="titlebj"
                      :header-cell-style="{background:'#f5f7f8',color:'#333333'}"
                      :row-style="{ height: '56px' }"
                    >
                      <el-table-column type="index" label="序号" align="center" width="70">
                      </el-table-column>
                      <el-table-column
                        prop="orderno"
                        label="积分事项"
                      ></el-table-column>
                      <el-table-column
                        prop="topuptime"
                        label="积分"
                        width="180"
                      ></el-table-column>
                      <el-table-column prop="topupname" label="总积分"></el-table-column>
                      <el-table-column prop="topupmoney" label="可用积分"></el-table-column>
                      <el-table-column
                        prop="topupperson"
                        label="积分时间"
                        width="120"
                      ></el-table-column>
                    </el-table>
                  </div>
                </el-col>
            </el-row>
              <!-- 分页 -->
              <div class="block">
                <div class="pagingwb">
                  <span style="font-size: 14px"> 总条数：{{ alls }} </span>
                  <span style="font-size: 14px; margin-left: 18px">
                    总积分：{{ totalPrice }}
                  </span>
                  <span style="font-size: 14px; margin-left: 18px">
                    可用总积分：{{ totalPrice }}
                  </span>
                </div>
                <div class="numberpage">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 15, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total_page"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
        </div>

        <!-- 意见反馈弹窗 -->
        <div v-if="couple" class="shez">
          <div class="fankui">
              <div class="jianjwb">
                <img src="../assets/images/jianja.png" alt="">
              </div>
              <div class="imggubiwb" @click="Retroaction">
                <img src="../assets/images/imggubi.png" alt="">
              </div>
              <div class="titlewbfk">
                <div class="titleb">意见反馈</div>
                <div class="xiabia"></div>
              </div>
              <div class="qrcodewb">
                  <div class="kuangk">
                     <div class="erwimwb">
                      <img src="../assets/images/Qrcode.jpg" style="width: 140px; height:140px;" />
                     </div>
                  </div>
                  <div class="textenbv">
                      <span  style="font-weight:bold;">使用微信扫一扫进入小程序填写意见建议哦~</span>
                  </div>
              </div>
          </div>
        </div>
        <div class="popup_tc" id="popuptc">
          <div class="popup"></div>
          <div class="popup_srk">
            <div class="gb_meniu" id="close_xx" onclick="closexxa()">
              <img src="../assets/images/gb.png" alt="" />
            </div>
            <div class="popup_bt">切换管理机构</div>
            <div class="text_jg">
              <input type="text" name="" placeholder="请选择门店" />
              <img src="../assets/images/xzxl.png" alt="" />
            </div>
            <div class="push_button">
              <button type="button" class="define_bt">
                <span>确定</span>
              </button>
              <button
                type="button"
                class="cancel_bt"
                id="cancel_bbt"
                onclick="cancelbta()"
              >
                <span>取消</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <contentbox_ban></contentbox_ban> -->
      <el-dialog
        title="切换管理机构"
        width="500px"
        :visible.sync="XZDialogVisible"
        :append-to-body="true"
        center
      >
        <el-row>
          <el-col :span="24">
            <el-select
              style="width: 100%"
              v-model="cpTypeAK_sel"
              filterable
              size="mini"
              placeholder="请选择机构"
            >
              <el-option
                v-for="item in cpTypeAK_return"
                :key="item.agenceid"
                :label="item.shopname"
                :value="item.agenceid"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="qiejigoubtn" size="mini"
            >确 定</el-button
          >
          <el-button type="primary" @click="XZDialogVisible = false" size="mini"
            >取 消</el-button
          >
        </div>
      </el-dialog>

      <!-- 充值弹层  -->
      <div id="dialog" v-if='dialogfalse'>
        <!-- 充值提醒 -->
        <div class="borders" v-if='remindfalse'>
          <div class="tit">
            <img class="tit_vip" src="../assets/chongzhi/lookup.png" alt="">
            <!-- <img src="../assets/chongzhi/bij.png" alt=""> -->
          </div>
          <div class="tit_QP " v-if="Maturities.activitynum > 0"><div class="tit_QP_T">距年付优惠活动结束仅剩<a class="tit_QP_X font_bold">{{Maturities.activitynum}}</a>天</div> </div>
          <div class="tit_QP " v-if="Maturities.activitynum <= 0"><div class="tit_QP_T">年付优惠活动已经结束！</div> </div>
          <div class="font_19 font_bold tit_box" v-if="Maturities.agencenum > 0">您的POS开票系统使用权限将于<a class="color_red font_24">{{Maturities.agencenum}}天后过期</a>，为了能够正常使用请<a class="color_red">提前续费</a>哦~</div>
          <div class="font_19 font_bold tit_box" v-if="Maturities.agencenum <= 0">您的POS开票系统使用权限<a class="color_red font_24">已过期</a>，请立即续费！</div>
          
          <!-- <div class="hint">
            <div class="hint_txt">
              <div class="hint_tit color_red font_bold">温馨提示</div>
              <div class="hint_describe letter_spac1" v-html="Maturities.prompt"></div>
            </div>
          </div> -->

          <div class="select flex-between-center">
            <!-- <div class="box" :class="m_style[0]"  @click="change(0)">
              <div class="font_bold line-h">3个月</div>
              <div class="color_red font_18">￥<a class="color_red font_bold font_24">{{number[0].money}}</a>/{{number[0].topupname}}</div>
            </div>
            <div class="box" :class="m_style[1]" @click="change(1)">
              <div class="font_bold line-h">6个月</div>
              <div class="color_red font_18">￥<a class="color_red font_bold font_24">{{number[1].money}}</a>/{{number[1].topupname}}</div>
            </div> -->
            <div class="box" :class="m_style[2] " @click="change(2)">
              <div class="hot"><img class="hot_img" src="../assets/chongzhi/hot.png" alt=""></div>
              <div class="font_bold " :class="line">年付 <a class="color_red font_14" v-if="Maturities.activitynum > 0">(8.9折)</a></div>
              <div class="text-dec font_14 color_gray" v-if="Maturities.activitynum > 0">￥1200</div>
              <div class="color_red font_18">￥<a class="color_red font_bold font_24">{{number[2].money}}</a>/{{number[2].topupname}}</div>
            </div>
          </div>

          <div class="serveVIP"><div class="color_red font_bold">{{ Maturities.description }}</div></div>

          <div class="flex-between-center renew">
            <div @click="takeup" v-if="continuend"><img src="../assets/chongzhi/takeup.png" alt=""></div>
            <div @click="closeshow" v-if="closehide"><img src="../assets/chongzhi/closeicon.png" alt=""></div>
            <div @click="payicon"><img src="../assets/chongzhi/payicon.png" alt=""></div>
          </div>
        </div>

        <!-- 充值二维码 -->
        <div class="pay" v-if="payfalse">
          <div class="pay_tit font_22 letter_spac1">微信支付</div>
          <div class="pay_EWM">
            <div id="qrcode" ref="qrcode" class="chong_qr"></div>
          </div>
          <div class="letter_spac1 color_red">充值金额：{{ m_money }} 元</div>
          <div class="letter_spac1">使用微信扫一扫支付，支付完成后，请点击已支付！</div>
          <div class="flex-between-center pay_btn">
            <div @click="giveUp"><img src="../assets/chongzhi/zhifu_03.png" alt=""></div>
            <div @click="zhifu" v-bind:disabled="isProcessing"><img src="../assets/chongzhi/zhifu_04.png" alt=""></div>
          </div>
        </div>
        <!-- 充值成功 -->
        <div class="pay" v-if="succeedfalse">
          <div class="pay_tit font_22 letter_spac1">成功提示</div>
          <div class="pay_success">
            <div class="font_22">恭喜你充值成功</div>
            <div class="font_14">本次充值金额<a class="font_22 color_red"> {{m_money}}元</a>，请截图至财务处用于储存凭证哦~</div>
            <div class="flex-between-center">
              <div class="font_14">充值店铺：{{Maturities.agencename}}</div>
            </div>
            <div class="flex-between-center">
              <div class="font_14">到期日期：{{ maturitiesdate }}</div>
            </div>
            
          </div>
          <div class="flex-between-center success_btn" @click="successb">
            <div><img src="../assets/chongzhi/successb.png" alt=""></div>
          </div>
        </div>

	    </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import header_menu from "@/components/header";
import nav_menu from "@/components/menu_left";
import contentbox_ban from "@/components/contentbox_ban";
import { networkState, networkSpeed, measureBW } from "../router/speed";
import $ from "jquery";
export default {
  data() {
    return {
      gridData: [],
      // number:["270","540","960"],
      isProcessing:false,
      number:[],
      line:'',
      m_money:960,//选择的充值金额
      m_topupname:'年',//选择的充值金额
      m_style: ["box", "box", "box_select"],
      dialogfalse:false,//充值弹窗true
      remindfalse:false,//充值提醒true
      payfalse:false,//充值二维码
      succeedfalse:false,//充值成功false
      Maturities:'',//机构到期查询
      maturitiesdate:'',//本次充值后到期日期
      miaoshi:'<p>爱恋珠宝持续免费提供零售终端系统并自主负担全部开发及维护，2022年以来阿里云、腾讯云、企业微信等各类供应商持续涨价，成本投入巨大。<br/> 为保证未来能持续维护，自2023年6月1日00:00开始，零售系统每个店铺终端每天收取3元成本费用，敬请理解（每个终端下可开设无限用户账号），为保证您的使用权益，请及时续费</p>',
      posURL:'',//pos跳转
      lok:'',//pos跳转
      systemid:'',//pos跳转
      winh: window.innerHeight - 140,
      topshow: false,
      leftshow: false,
      mainshow: false,
      isCollapse: true,
      dialogTableVisible: false,
      dialogTableVisible_ruku: false,
      staff_url: "http://posstaff.ailend.hk/#/",
      pageData: [],
      ifact: false,
      isactive: "",
      username: "", //姓名
      userno: "", //帐号networkSpeed
      mobiphone: "", //手机号
      agenceid: "", //机构id
      shopname: "", //机构名称
      cpTypeAK_sel: "", //选中的机构
      cpTypeAK_return: [], //机构列表
      XZDialogVisible: false, //切换机构弹层显示
      getSpeed: "", // 获取网速状态
      isture: false,

      shez_tc: false,
      Rechquery:false, //充值查询弹窗显示
      couple:false, //意见反馈弹窗显示
      integrall:false, //积分明细弹窗显示
      currentPage: 0,
      // invest:1,
      continuend:true,//继续使用按钮显示
      closehide:false//关闭按钮显示
    };
  },

  components: {
    header_menu,
    nav_menu,
    contentbox_ban,
  },

  computed: {},
  created: function () {
    let testString = "abdewl";
    console.log("浏览器", (navigator.connection.downlink * 1024) / 8);
    
  },

  mounted: function () {
    this.getSpeedBtn();
    if (localStorage.tnk) {
      API.IPHONE_TOKEN = localStorage.tnk;
    } else {
      setTimeout(() => {
        this.log_out();
      }, 1000);
    }
    var _this = this;
    // setTimeout(() => {
    //   this.topshow = true;
    // }, 300);
    // setTimeout(() => {
    //   this.leftshow = true;
    // }, 400);
    // setTimeout(() => {
    //   this.mainshow = true;
    // }, 500);

    //获取用户信息
    let postData_code = _this.$qs.stringify({
      version: API.VERSION_NUM,
      iphone: localStorage.tnk,
      sysid: "",
    });
    _this
      .$axios({
        url: API.API_TOKEN + "PublicUser/UserInfoByIphone",
        method: "POST",
        data: postData_code,
      })
      .then((res) => {
        if (res.data.error_code == 0) {
          this.username = res.data.data[0].username;
          this.userno = res.data.data[0].userno;
          this.mobiphone = res.data.data[0].mobiphone;
          this.agenceid = res.data.data[0].agenceid;
          this.shopname = res.data.data[0].shopname;
        } else if (res.data.error_code == 40001) {
          _this.$message.error("页面过期，222请重新登陆！");
          // setTimeout(function() {
          //   window.parent.location.href = "";
          //   window.parent.close();
          // }, 1000);
        } else {
          _this.$message.error("获取机构失败，请重新登录");
        }
      });

      this.$http.post(
        API.API_TOKEN + "Pub_PageJurisdiction/GetSystemmeau",
        this.$qs.stringify({
          version: API.VERSION_NUM,
          iphone: localStorage.tnk,
        })
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.error_code == 0) {

          for(let i=0;i<res.data.data.length;i++){
            if(res.data.data[i].title == "用户集成平台"){
              res.data.data[i].icon = "Icon_01.png";
              res.data.data[i].stateid = "yh_bj_01.png";
            }else if(res.data.data[i].title == "服务工单系统"){
              res.data.data[i].icon = "Icon_02.png";
              res.data.data[i].stateid = "gd_bj_02.png";
            }else if(res.data.data[i].title == "云销售平台"){
              res.data.data[i].icon = "Icon_03.png";
              res.data.data[i].stateid = "pos_bj_03.png";
            }else if(res.data.data[i].title == "云订货平台"){
              res.data.data[i].icon = "Icon_04.png";
              res.data.data[i].stateid = "wd_bj_04.png";
            }else if(res.data.data[i].title == "云订货管理平台"){
              res.data.data[i].icon = "Icon_05.png";
              res.data.data[i].stateid = "gl_bj_05.png";
            }else if(res.data.data[i].title == "帆软报表"){
              res.data.data[i].icon = "Icon_06.png";
              res.data.data[i].stateid = "fr_bj_06.png";
            }else if(res.data.data[i].title == "中间件管理平台"){
              res.data.data[i].icon = "Icon_07.png";
              res.data.data[i].stateid = "bj_07.png";
            }
          }
          this.pageData = res.data.data;
        }
      });
      this.jigouboxin();
  },
  watch: {
    ifact: function () {
      if (this.ifact) {
        this.isactive = "active";
      } else {
        this.isactive = "";
      }
    },
  },

  methods: {
    chaxun(){
      let _this = this
      if(this.couple == true){
        this.couple = false
        let UpCallbackData = _this.$qs.stringify({
        iphone: localStorage.tnk,
        agenceid:_this.Maturities.agenceid,
      });
      this.Rechquery=true
      _this
        .$axios({
          url: API.API_TOKEN + "SysExpense/GetTopUpQRLog",
          method: "POST",
          data: UpCallbackData,
        })
        .then((res) => {
          console.log('充值查询',res);
          if(res.data.error_code == 200){
            _this.gridData = res.data.data
          }
          else{
            this.$message({
                  message: res.data.error_message,
                  type: "warning",
                });
          }
        })
      }else{
        let UpCallbackData = _this.$qs.stringify({
        iphone: localStorage.tnk,
        agenceid:_this.Maturities.agenceid,
      });
      this.Rechquery=true
      _this
        .$axios({
          url: API.API_TOKEN + "SysExpense/GetTopUpQRLog",
          method: "POST",
          data: UpCallbackData,
        })
        .then((res) => {
          console.log('充值查询',res);
          if(res.data.error_code == 200){
            _this.gridData = res.data.data
          }
          else{
            this.$message({
                  message: res.data.error_message,
                  type: "warning",
                });
          }
        })
      }

    },
    //立即充值弹窗
    nowinvest(){
      // this.dialogfalse=true,//充值弹窗true
      // this.remindfalse=true//充值提醒true
        this.continuend = false
        this.closehide = true
      // console.log('1----',invest)
      let _this = this;
      if(this.Rechquery == true || this.couple == true){
        this.Rechquery = false
        this.couple = false
        let chongData = _this.$qs.stringify({
        iphone: localStorage.tnk,
      });
      _this
         .$axios({
            url: API.API_TOKEN + "SysExpense/GetMaturities",
            method: "POST",
            data: chongData,
     })
      .then((rec) => {
      console.log('机构daoq111111',rec);
      let isshow = rec.data.isshow
      _this.Maturities = rec.data
      this.dialogfalse=true,//充值弹窗true
      this.remindfalse=true//充值提醒true
      if(rec.data.activitynum > 0){
        _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
        _this.m_money = 1200
        _this.line = 'line-N'
      }else{
      _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
      _this.m_money = 1200
      _this.line = 'line-h'
      }
      })
      }else{
        let chongData = _this.$qs.stringify({
        iphone: localStorage.tnk,
      });
      _this
         .$axios({
            url: API.API_TOKEN + "SysExpense/GetMaturities",
            method: "POST",
            data: chongData,
     })
      .then((rec) => {
      console.log('机构daoq2222',rec);
      let isshow = rec.data.isshow
      _this.Maturities = rec.data
      this.dialogfalse=true,//充值弹窗true
      this.remindfalse=true//充值提醒true
      if(rec.data.activitynum > 0){
        _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
        _this.m_money = 1200
        _this.line = 'line-N'
      }else{
      _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
      _this.m_money = 1200
      _this.line = 'line-h'
      }
      })
      }
    },
    //充值弹窗的关闭按钮
    closeshow(){
      this.dialogfalse=false,//充值弹窗true
      this.remindfalse=false//充值提醒true
    },
    //关闭充值查询界面
    outguanb(){
      this.Rechquery=false
    },
    //关闭意见反馈弹窗
    Retroaction(){
      this.couple=false
    },
    //打开意见反馈弹窗
    Feedback(){
      if(this.Rechquery == true){
        // alert("请先关闭已开的窗口");
        this.Rechquery = false;        
        this.couple=true
      }else{
        this.couple=true
      }
    },
    //关闭积分明细
    Pointsdetails(){
      this.integrall=false
    },
    //积分明细提示
    Integral(){
      if(this.Rechquery == true || this.couple == true){
      this.Rechquery = false
      this.couple = false
      this.$message({
        message: '暂未开通，敬请期待！',
        type: "warning",
      });
      }else{
        this.$message({
        message: '暂未开通，敬请期待！',
        type: "warning",
      });
      }

    },
    handleCurrentChange(val) {
      //控制去到第几页的
      this.currentPage = val;
      this.SaleListGet();
    },
    handleSizeChange(val) {
      //控制每页显示多少条的
      this.pageSize = val;
      this.SaleListGet();
    },
    // 充值选择
    change(a) {
        // 把所有元素初始化样式为box
        for (let i = 0; i < this.m_style.length; i++) {
          console.log('yangs',this.m_style[i]);
          this.$set(this.m_style, i, "box");
        }
          this.m_money=this.number[a].money;
          this.m_topupname=this.number[a].topupname;
          console.log('000----',a);
        // 修改当前点击元素为新样式
        this.$set(this.m_style, a, "box_select");
    },
    // 继续使用
    takeup(){
      let agencenum = this.Maturities.agencenum
      if(agencenum <= 0){
        this.$message.error(
          "您的POS开票系统使用权限已过期，请立即续费！"
        );
      }else{
        this.dialogfalse = false
        window.open(this.posURL + "?lok=" + this.lok + "&systemid=" + this.systemid);
      } 
    },
    // takeup(){
    //   let _this = this
    //   let invest = this.invest
    //   console.log('0----',this.invest)
    //   if(invest == 1){
    //     this.dialogfalse=false,//充值弹窗true
    //     this.remindfalse=false//充值提醒true
    //   }else{
    //     let agencenum = this.Maturities.agencenum
    //     if(agencenum <= 0){
    //     this.$message.error(
    //       "您的POS开票系统使用权限已过期，请立即续费！"
    //     );
    //   }else{
    //     this.dialogfalse = false
    //     window.open(this.posURL + "?lok=" + this.lok + "&systemid=" + this.systemid);
    //   } 
    //   }
    // },
    // 立即续费
    payicon(){
      let _this = this
      let UpQRCodeData = _this.$qs.stringify({
        iphone: localStorage.tnk,
        agenceid:_this.Maturities.agenceid,
        topupname:_this.m_topupname,
        money:_this.m_money,
      });
      _this
        .$axios({
          url: API.API_TOKEN + "SysExpense/TopUpQRCode",
          method: "POST",
          data: UpQRCodeData,
        })
        .then((res) => {
          console.log('充值二维码',res);
          _this.qrcode = res.data.qrcode;
          _this.orderno= res.data.orderno;
          _this.outtradeno= res.data.outtradeno;
          // 使用$nextTick确保数据渲染
          _this.$nextTick(() => {
            _this.crateQrcode();
          });
        })
        _this.remindfalse = false
        _this.payfalse = true
    },
    // 生成二维码
    crateQrcode() {
      this.qr = new QRCode("qrcode", {
        width: 180,
        height: 180, // 高度
        text: this.qrcode, // 二维码内容
        background: "#f0f"
      });
    },

    // 放弃支付
    giveUp(){
      this.$refs.qrcode.innerHTML = "";
      this.payfalse = false
      this.remindfalse = true
    },

    // 支付完成
    zhifu(){
      let _this = this
      _this.isProcessing = true
      let UpCallbackData = _this.$qs.stringify({
        iphone: localStorage.tnk,
        agenceid:_this.Maturities.agenceid,
        orderno:_this.orderno,
        outtradeno:_this.outtradeno,
      });
      _this
        .$axios({
          url: API.API_TOKEN + "SysExpense/TopUpCallback",
          method: "POST",
          data: UpCallbackData,
        })
        .then((res) => {
          console.log('支付完成',res);
          if(res.data.error_code == 200){
            _this.maturitiesdate = res.data.maturitiesdate
            _this.succeedfalse = true
            _this.payfalse = false
            _this.isProcessing = false
            _this.$refs.qrcode.innerHTML = "";
          }
          if(res.data.error_code == -1){
            this.$message({
                  message: res.data.error_message,
                  type: "warning",
                });
          }
        })
    },
    // 支付结束 好的按钮
    successb(){
      this.succeedfalse = false
      this.dialogfalse = false
      window.open(this.posURL + "?lok=" + this.lok + "&systemid=" + this.systemid);
    },
    //显示优良差
    changeState(v) {
      console.log(v);
      let _this = this;
      this.isture = true;
      setTimeout(function () {
        if (v < 100) {
          _this.getSpeed = "差";
        } else if (v < 1000) {
          _this.getSpeed = "良";
        } else {
          _this.getSpeed = "优";
        }
        _this.isture = false;
      }, 1000);
    },
    // 点击获取网速
    getSpeedBtn() {
      this.isture = true;
      let gogeSpedd = (navigator.connection.downlink * 1024) / 8;
      if (navigator.userAgent.includes("Chrome")) {
        this.isture = false;
        this.changeState(gogeSpedd);
      } else {
        measureBW((speed) => {
          this.changeState(speed);
          this.isture = false;
        });
      }
    },
    //跳转到对应的位置
    changePo() {
      let htmlBox = this.$el.querySelector(".drumpPosition");
      this.$nextTick(() => {
        document.documentElement.scrollTop = htmlBox.offsetTop;
      });
    },
  

    //打开用户设置
    useropen: function () {
      this.ifact = !this.ifact;
      if (this.ifact) {
        this.jigouboxin();
      }
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },

    //登出
    log_out: function () {
      localStorage.tnk = "";
      this.$store.state.editableTabs2 = [];
      setTimeout(() => {
        this.mainshow = false;
      }, 300);
      setTimeout(() => {
        this.leftshow = false;
      }, 500);
      setTimeout(() => {
        this.topshow = false;
      }, 700);
      setTimeout(() => {
        this.$router.push({
          path: "/",
        });
      }, 1000);
    },
    // 获取机构可用日期
    GetMaturities(){
      let _this = this;
      // let postData_code = _this.$qs.stringify({
      //   iphone: localStorage.tnk,
      // });
      let chongData = _this.$qs.stringify({
        iphone: localStorage.tnk,
      });
      _this
        .$axios({
          url: API.API_TOKEN + "SysExpense/GetMaturities",
          method: "POST",
          data: chongData,
        })
        .then((res) => {
          console.log('机构daoq',res);
        })
    },
    // 跳转帆软
    urlgo: function (objects, j, i, titles) {
      // this.GetMaturities();
      let _this = this;
      let istest = API.ISTEST;
      let key = encodeURIComponent(localStorage.tnk);

      let postData_code = _this.$qs.stringify({
        version: API.VERSION_NUM,
        iphone: localStorage.tnk,
        sysid: i,
      });
      _this
        .$axios({
          url: API.API_TOKEN + "PublicUser/UserInfoByIphone",
          method: "POST",
          data: postData_code,
        })
        .then((res) => {
          if (res.data.error_code == 0) {
            if (titles == "帆软报表") {
              if (j) {
                // 正式
                $.ajax({
                  url: objects + "/WebReport/decision/login/cross/domain",
                  data: {
                    fine_username: localStorage.pe,
                    fine_password: localStorage.frmv,
                    validity: -1,
                  },
                  dataType: "jsonp",
                  callback: "callback",
                  success: function (res) {
                    window.open(objects + "/WebReport/decision/");
                  },
                });

                // this.$jsonp(objects + '/WebReport/decision/login/cross/domain', {fine_username:localStorage.pe,fine_password:localStorage.frmv,validity: -1,callback:"callback"}).then(json => {
                //   console.log(this.userno);
                //   window.open(objects+"/WebReport/decision/");
                // }).catch(err => {
                // 　　this.$message.error("帆软报表登录异常！！");
                // })
              } else {
                this.$message({
                  message: "该系统暂未开通",
                  type: "warning",
                });
              }
            } 
            else if(titles == "云销售平台"){
              this.continuend = true
              this.closehide = false
              // this.invest = ""
              if(!res.data.data[0].isusepos){
                this.$message.error(
                    "您未使用云销售平台，请联系技术部值班人员！！"
                  );
                  return false;
              }else{
                this.posURL = objects
                  this.lok = key
                  this.systemid = i
                  let chongData = _this.$qs.stringify({
                  iphone: localStorage.tnk,
                });
                _this
                  .$axios({
                    url: API.API_TOKEN + "SysExpense/GetMaturities",
                    method: "POST",
                    data: chongData,
                  })
                  .then((rec) => {
                    console.log('机构daoq333',rec);
                    let isshow = rec.data.isshow
                    _this.Maturities = rec.data
                    if(isshow == "True"){
                      this.dialogfalse=true,//充值弹窗true
                      this.remindfalse=true//充值提醒true
                    }else{
                      window.open(objects + "?lok=" + key + "&systemid=" + i);
                    }
                    if(rec.data.activitynum > 0){
                      _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
                      _this.m_money = 1200
                      _this.line = 'line-N'
                    }else{
                      _this.number = [{topupname:'3个月', money:330},{topupname:'6个月', money:600},{topupname:'年', money:1200}],
                      _this.m_money = 1200
                      _this.line = 'line-h'
                    }
                  }) 
              }
            }
             else {
              if (j) {
                console.log(titles);
                console.log(res.data.data[0].isusepos);
                window.open(objects + "?lok=" + key + "&systemid=" + i);
                // if (titles == "云销售平台" && !res.data.data[0].isusepos) {
                //   this.$message.error(
                //     "您未使用云销售平台，请联系技术部值班人员！！"
                //   );
                //   return false;
                // } else {
                //   this.posURL = objects
                //   this.lok = key
                //   this.systemid = i
                //   let chongData = _this.$qs.stringify({
                //   iphone: localStorage.tnk,
                // });
                // _this
                //   .$axios({
                //     url: API.API_TOKEN + "SysExpense/GetMaturities",
                //     method: "POST",
                //     data: chongData,
                //   })
                //   .then((rec) => {
                //     console.log('机构daoq',rec);
                //     let isshow = rec.data.isshow
                //     _this.Maturities = rec.data
                //     if(isshow){
                //       this.dialogfalse=true,//充值弹窗true
                //       this.remindfalse=true//充值提醒true
                //     }else{
                      
                //       window.open(objects + "?lok=" + key + "&systemid=" + i);
                //     }
                //   }) 
                // }
              } else {
                this.$message({
                  message: "该系统暂未开通",
                  type: "warning",
                });
              }
            }
          } else if (res.data.error_code == 40001) {
            _this.$message.error("页面过期，请重新登陆！");
            setTimeout(function () {
              window.parent.location.href = "";
              window.parent.close();
            }, 1000);
          } else {
            _this.$message.error("获取机构失败，请重新登录");
          }
        });
    },

    //获取机构下拉数据
    jigouboxin: function () {
      let _this = this;
      let postData_codes = _this.$qs.stringify({
        iphone: localStorage.tnk,
        version: API.VERSION_NUM,
      });
      console.log('手机',localStorage.tnk)
      _this
        .$http({
          url: API.API_TOKEN + "Pub_PageJurisdiction/GetUseragenceid",
          method: "POST",
          data: postData_codes,
        })
        .then((res) => {
          console.log("数据", res);
          if (res.data.error_code == 0) {
            _this.cpTypeAK_return = res.data.data;
            _this.cpTypeAK_sel = parseInt(_this.agenceid);
          } else if (res.data.error_code == 40001) {
            _this.$message.error("页面过期，请重新登陆！");
            setTimeout(function () {
              window.parent.location.href = "";
              window.parent.close();
            }, 1000);
          } else {
            _this.$message.error(res.data.error_message);
          }
        });
    },

    //切换机构确认按钮
    qiejigoubtn: function () {
      let _this = this;
      if (_this.agenceid == _this.cpTypeAK_sel) {
        _this.$message({
          type: "error",
          message: "机构无变化！",
        });
      } else {
        let postData_codes = _this.$qs.stringify({
          iphone: localStorage.tnk,
          agenceid: _this.cpTypeAK_sel,
          version: API.VERSION_NUM,
        });
        _this
          .$http({
            url: API.API_TOKEN + "Pub_PageJurisdiction/SetUseragenceid",
            method: "POST",
            data: postData_codes,
          })
          .then((res) => {
            if (res.data.error_code == 0) {
              localStorage.fzhitype = "";
              localStorage.equitygroupid = "";
              localStorage.tnk = "";
              _this.$message({
                type: "success",
                message: "切换机构成功，请重新登陆！",
              });
              _this.XZDialogVisible = false;
              setTimeout(function () {
                if (API.ISTEST == 1) {
                  window.location.href = "http://users.ailend.hk/#/";
                } else if (API.ISTEST == 2) {
                  window.location.href = "http://member.myailand.cn/#/";
                } else if (API.ISTEST == 3) {
                  window.location.href = "http://webtest59.ailend.info:9101/#/";
                }
              }, 1000);
            } else if (res.data.error_code == 40001) {
              _this.$message.error("页面过期，请重新登陆！");
              setTimeout(function () {
                window.parent.location.href = "";
                window.parent.close();
              }, 1000);
            } else {
              _this.$message.error(res.data.error_message);
            }
          });
      }
    },

    //注销用户
    outusers: function () {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.fzhitype = "";
          localStorage.equitygroupid = "";
          localStorage.tnk = "";
          if (API.ISTEST == 1) {
            window.location.href = "http://users.ailend.hk/#/";
          } else if (API.ISTEST == 2) {
            window.location.href = "http://member.myailand.cn/#/";
          } else if (API.ISTEST == 3) {
            window.location.href = "http://webtest59.ailend.info:9101/#/";
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消退出登录。",
          });
        });
    },

    showa(){
      this.shez_tc = true;
      this.jigouboxin();
    },
    // 关闭设置弹窗
    hideb(){
      this.shez_tc = false;
    },
    move(inx) {
      const card = this.$refs.card
      // const refl = this.$refs.refl;
      const relX = (event.offsetX + 1) / card[inx].offsetWidth;
      const relY = (event.offsetY + 1) / card[inx].offsetHeight;
      const rotY = `rotateY(${(relX - 0.4) * 40}deg)`;
      const rotX = `rotateX(${(relY - 0.4) * -40}deg)`;
      card[inx].style.transform = `perspective(500px) ${rotY} ${rotX}`;
      // const lightX = this.scale(relX, 0, 1, 150, -50);
      // const lightY = this.scale(relY, 0, 1, 30, -100);
      // const lightConstrain = Math.min(Math.max(relY, 0.3), 0.7);
      // const lightOpacity = this.scale(lightConstrain, 0.3, 1, 1, 0) * 255;
      // const lightShade = `rgba(${lightOpacity}, ${lightOpacity}, ${lightOpacity}, 1)`;
      // const lightShadeBlack = `rgba(0, 0, 0, 1)`;
      // refl.style.backgroundImage = `radial-gradient(circle at ${lightX}% ${lightY}%, ${lightShade} 20%, ${lightShadeBlack})`;
    },
    leave(inx) {
      const card = this.$refs.card[inx];
      card.style.transform = `perspective(500px)`;
    },


  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

html,
body {
  background: #fff5f7;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
/* 充值弹窗 */
#dialog {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.45);
    z-index: 10;
    width: 100%;
    overflow: auto;
    height: 100%;
}
.borders{
    text-align: center;
    width: 49%;
    border-radius: 17px;
    background: #fff;
    /* height: 100%; */
    overflow-y: auto;
    position: absolute;
    z-index: 11;
    left: 50%;
    top: 98px;
    transform: translate(-50%,0%) !important;
  }
.tit{
  /* background-image: url('../assets/chongzhi/bij.png'); */
  background: url('../assets/chongzhi/bij.png') no-repeat;
  background-size: 100% 100%;
  height: 150px;
  position: relative;
  /* width: 100%; */
}
.tit_box{
  width: 94%;
  margin: 0 auto;
}
.tit .tit_vip{
  width: 30%;
  position: absolute;
  top: 17%;
  left: 18%;
}
.tit_QP{
  background: url('../assets/chongzhi//Daysbj.png') no-repeat;
  background-size: 100% 100%;
  /* width:30%; */
  position: absolute;
  top: 5%;
  left: 48%;
  height: 44px;
  color: #B10AF6;
}
.tit_QP_T{
  line-height: 30px;
  text-align: left;
  width: 90%;
  margin: 4px 20px 4px 26px;
}
.tit_QP_X{
  background: #fff;
  margin: 0 5px;
  padding: 0 5px;
}
.hint{
  width: 74%;
  margin: 26px auto;
  background-color: #F3F3F3;
  border-radius: 9px;
}
.hint_txt{
  width: 94%;
  margin: 0 auto;
  text-align: left;
  padding: 10px 0 10px 0;
}
.hint_describe{
  color: #696969;
  line-height:26px
}
/* .hint_tit{
  text-align: left;
} */
.select {
        width: 74%;
        margin: 20px auto;
        display: flex;
        justify-content: center;
    }
 
.box {
  position: relative;
    /* float: left; */
    height: 140px;
    width: 210px;
    background-color: rgb(255, 255, 255);
    margin-left: 20px;
    text-align: center;
    border-radius: 10px;
    border: 1px rgb(212, 211, 211) solid;
    font-size: 20px;
}
.box1 {
  position: relative;
    /* float: left; */
    height: 140px;
    width: 210px;
    background-color: rgb(247, 247, 247);
    margin-left: 20px;
    text-align: center;
    border-radius: 10px;
    border: 1px rgb(212, 211, 211) solid;
    font-size: 20px;
    pointer-events: none;
    cursor: default;
}
.box2 {
  position: relative;
    /* float: left; */
    height: 140px;
    width: 210px;
    background-color: rgb(247, 247, 247);
    margin-left: 20px;
    text-align: center;
    border-radius: 10px;
    border: 1px rgb(212, 211, 211) solid;
    font-size: 20px;
    pointer-events: none;
    cursor: default;
}
.line-h{
  /* line-height: 70px; */
  margin: 28px 0;
}
.line-N{
  margin: 28px 0 0 0;
}


.box_select {
    /* border: 2px rgb(248, 2, 2) solid; */
    border: 2px #FC5623 solid;
    
}
.hot{
  width: 18%;
  position: absolute;
  top: -6%;
  right: -0.5%;
}
.hot_img{
  width: 100%;
}
.serveVIP{
  background: #FFF5F2;
  width: 40%;
  line-height: 40px;
  margin: 26px auto;
}
.renew{
  width: 50%;
  margin: 26px auto;
  /* border: 1px solid forestgreen; */
}
/* 支付弹窗 */
.pay{
  text-align: center;
  width: 26%;
  border-radius: 17px;
  background: #fff;
  /* height: 100%; */
  overflow-y: auto;
  position: absolute;
  z-index: 9999;
  left: 50%;
  top: 30%;
  transform: translate(-50%,0%) !important;
}
.chong_qr{
  margin: 10px 8px;
}
.pay_tit{
  background: #C451B8;
  line-height: 60px;
  color: #fff;
}
.pay_EWM{
  width: 200PX;
  height: 200PX;
  border: 1px green solid;
  margin: 30px auto;
  /* position:relative;
  margin: 30px auto;
  width: 40%;
  height: 0;
  border: 1px green solid;
  padding-bottom:40% */
}
.pay_btn{
  width: 50%;
  margin: 20px auto;
}
.pay_btn img{
  width: 100%;
}
.pay_success{
  width: 76%;
  margin: 60px auto;
  line-height: 36px;
}
.success_btn{
  width: 30%;
  margin: 0 auto;
}
.success_btn img{
  width: 100%; 
}

/*  */
.indexbox {
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/images/bj.png");
  /* overflow: hidden; */
}
.bar {
  width: 100%;
  height: 84px;
}

.head {
  width: 930px;
  height: 84px;
  margin: 0 auto;
}

.logo {
  width: 91px;
  height: 76px;
  background: #f198a7;
  border-radius: 10px;
  text-align: center;
  float: left;
  margin-top: 4px;
}

.el_logo {
  padding-top: 26px;
}

.wj-but {
  background-color: #f198a7;
  color: white;
  height: 39px;
  width: 46px;
  outline: none;
  border-radius: 4px;
  text-align: right;
}
.CX-but {
  background-color: #f198a7;
  color: white;
  /* height: 25px; */
  width: 96px;
  /* outline: none; */
  border-radius: 4px;
  text-align: center;
  /* line-height: 25px; */
}
.shez {
  float: right;
  padding-top: 26px;
}

.bj {
  float: left;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.bi_middle {
  width: 940px;
  height: 760px;
  /* background-color: red; */
  margin: 0 auto;
  margin-top: 10px;
  z-index: 2;
}

.biaot {
  text-align: center;
}

.user {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  margin-top: 20px;
  position: relative;
  display: inline-block;
  vertical-align: top;
  /* background-image: url('../assets/images/yh_bj_01.png');
    Background-repeat:no-repeat;  */
}

.hide_bj {
  position: relative;
  margin-top: -150px;
}

.user_tp {
  padding-top: 50px;
}

.texs {
  font-weight: bold;
  padding-top: 6px;
}

.texs2 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user2 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-top: 20px;
  margin-right: 20px;
  /* background-image: url('../assets/images/gd_bj_02.png');
    Background-repeat:no-repeat;  */
}

.hide_bj2 {
  position: relative;
  margin-top: -150px;
}

.user_tp2 {
  padding-top: 50px;
}

.texs_02 {
  font-weight: bold;
  padding-top: 6px;
}

.news {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user3 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-top: 20px;
  margin-left: 20px;
  /* background-image: url('../assets/images/pos_bj_03.png');
    Background-repeat:no-repeat;  */
}

.hide_bj3 {
  position: relative;
  margin-top: -160px;
}

.user_tp3 {
  padding-top: 50px;
}

.texs_03 {
  font-weight: bold;
  padding-top: 6px;
}

.news_03 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user4 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  margin-top: 24px;
  position: relative;
  display: inline-block;
  /* background-image: url('../assets/images/wd_bj_04.png');
    Background-repeat:no-repeat;  */
}

.hide_bj4 {
  position: relative;
  margin-top: -150px;
}

.user_tp4 {
  padding-top: 50px;
}

.texs_04 {
  font-weight: bold;
  padding-top: 6px;
}

.news_04 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user5 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-top: 24px;
  margin-left: 20px;
  /* background-image: url('../assets/images/gl_bj_05.png');
    Background-repeat:no-repeat;  */
}

.hide_bj5 {
  position: relative;
  margin-top: -190px;
}

.user_tp5 {
  padding-top: 50px;
}

.texs_05 {
  font-weight: bold;
  padding-top: 6px;
}

.news_05 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user6 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin-top: 24px;
  margin-left: 20px;
  /* background-image: url('../assets/images/fr_bj_06.png');
    Background-repeat:no-repeat;  */
}

.hide_bj6 {
  position: relative;
  margin-top: -170px;
}

.user_tp6 {
  padding-top: 50px;
}

.texs_06 {
  font-weight: bold;
  padding-top: 6px;
}

.news_06 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.user7 {
  width: 290px;
  height: 240px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgb(255, 228, 228) 1px 1px 8px 1px;
  text-align: center;
  margin-top: 24px;
  position: relative;
  display: inline-block;
  /* background-image: url('../assets/images/bj_07.png');
    Background-repeat:no-repeat; */
}

.hide_bj7 {
  position: relative;
  margin-top: -190px;
}

.user_tp7 {
  padding-top: 50px;
}

.texs_07 {
  font-weight: bold;
  padding-top: 6px;
}

.news_07 {
  width: 220px;
  height: 60px;
  font-size: 8px;
  margin: 0 auto;
  color: #adadad;
  padding-top: 14px;
}

.shez_tk {
  width: 20%;
  height: 100%;
  background: rgba(255,245,247,0.4);
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: rgb(255, 208, 216) 1px 1px 8px 1px;
  z-index: 1;
  /* opacity:.60; */
}

.gb_code {
  width: 100%;
  /* height: 50px; */
  margin: 0 auto;
  text-align: center;
  padding: 25px;
  /* cursor: pointer; */
  /* border: 1px solid red; */
  background: #feeff2;
  margin-top: 16px;
}
.imgtanc{
  width: 60px;
  height: 50px;
  /* border: 1px solid red; */
}
.divimg{
  margin-left: 14px;
}

.content_box {
  /* height: 280px;
  width: 400px;
  background: rgba(255,245,247,0.2); */
  margin-top: 10px;
  padding-left: 20px;
}

.username {
  height: 40px;
  font-size: 14px;
}

.cell-phone {
  font-size: 14px;
  height: 40px;
}
.number{
  font-size: 14px;
  height: 40px;
}

.organ {
  font-size: 14px;
  height: 40px;
}

.network {
  font-size: 14px;
  height: 40px;
}
.xinxin{
  width: 24px;
  height: 24px;
  margin-top: 6px;
}
/* .xinxinwb{
  width: 24px;
  height: 24px;
} */
.jifenwb{
  width: 340px;
  font-size: 14px;
  display: flex;
  /* background: #feeff2; */
  background: rgba(255,230,235,0.4);
  height: 40px;
  line-height: 40px;
}
.available{
  margin-left: 40px;
}

.but_bt {
  background-color: #f198a7;
  color: white;
  outline: none;
  font-size: 16px;
  padding-top: 10px;
  outline: none;
  font-size: 14px;
}

.qh-but {
  background-color: #f198a7;
  color: white;
  border-radius: 6px;
  height: 30px;
  width: 72px;
}

.zx-but {
  background-color: #f198a7;
  color: white;
  border-radius: 6px;
  height: 30px;
  width: 72px;
}

.hr_fg {
  width: 100%;
}

.hq_wl {
  color: #f198a7;
  margin-right: 20px;
  padding: 0 80px;
}

.button_tc {
  margin-top: 20px;
}

.zx-but {
  background-color: #f198a7;
  color: white;
  width: 80px;
  height: 30px;
  border-radius: 6px;
  border: none;
  outline: none;
}

.qh-but {
  background-color: #f198a7;
  color: white;
  width: 80px;
  height: 30px;
  border-radius: 6px;
  border: none;
  outline: none;
}

.popup {
  position: absolute;
  background-color: black;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  opacity: 0.6;
}

.popup_srk {
  position: absolute;
  width: 490px;
  height: 290px;
  border: 10px solid #f198a7;
  background-color: white;
  top: 35%;
  left: 35%;
  padding: 20px;
  margin: 0 auto;
  z-index: 9999;
  overflow: auto;
}

.gb_meniu {
  margin-left: 414px;
  margin-top: -8px;
}

.popup_bt {
  text-align: center;
  margin-top: -20px;
  font-size: 18px;
}

.text_jg {
  outline: none;
  margin: 0 auto;
  text-align: center;
}

.text_jg input {
  width: 350px;
  height: 40px;
  border-radius: 8px;
  margin: 20px 0;
  background-color: white;
  background-position: 14px;
  padding-left: 10px;
  border: 1px solid #e4e4e4;
  outline: none;
  margin-top: 40px;
}

.text_jg img {
  position: relative;
  right: 25px;
}

.push_button {
  text-align: center;
  margin-top: 35px;
}

.define_bt {
  background-color: #f198a7;
  color: white;
  width: 60px;
  height: 30px;
  border-radius: 6px;
  border: none;
  outline: none;
}

.cancel_bt {
  background-color: #f198a7;
  color: white;
  width: 60px;
  height: 30px;
  border-radius: 6px;
  border: none;
  outline: none;
}

.popup_tc {
  display: none;
}
.el-button--primary{
  background-color: #F198A7;
  border-color: #F198A7;
}
/* 充值查询 */
.chargequ{
  width: 1060px;
  /* height: 100%; */
  background: #ffffff;
  position: absolute;
  top: 1.5%;
  right: 21%;
  box-shadow: rgb(255, 208, 216) 1px 1px 8px 1px;
  border-radius: 10px;
}
.jianjwb{
  float: right;
  position: relative;
  margin-right: -6px;
  margin-top: 10px;
}
.imggubiwb{
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
.titlewb{
  padding: 16px 0 0 20px;
  font-weight: bold;
}
.xiabia{
  width: 57px;
  height: 5px;
  background: #ff8297;
  border-radius: 10px;
  margin-top: -7px;
}
.biaogewb{
  margin-top: 10px;
  margin-left: 22px;
  margin-bottom: 20px;
}
/* .titlebj{
  background: #f0f2f5;
} */
/* 意见反馈 */
.fankui{
  width: 400px;
  height: 380px;
  background: #ffffff;
  position: absolute;
  top: 1.5%;
  right: 21%;
  box-shadow: rgb(255, 208, 216) 1px 1px 8px 1px;
  border-radius: 10px;
}
.kuangk{
		border: 1px solid #ff8297;
		width: 200px;
    height: 200px;
		margin: 0 auto;
	}
  .qrcodewb{
    text-align: center;
  }
  .titlewbfk{
    padding: 30px 0 30px 100px;
    font-weight: bold;
  }
  .textenbv{
    margin-top: 30px;
  }
  .erwimwb{
    margin-top: 22px;
  }
  /* 积分明细 */
  .ointails{
    width: 1060px;
  /* height: 100px; */
  background: #ffffff;
  position: absolute;
  top: 1.5%;
  right: 20%;
  box-shadow: rgb(255, 208, 216) 1px 1px 8px 1px;
  border-radius: 10px;
  }
  .box_kuang {
  margin-top: 16px;
  margin-left: 20px;
  padding-bottom: 10px;
  display: flex;
  /* border: 1px solid firebrick; */
}
.datatime{
  margin-left: 10px;
}
.wbtnb{
  margin-top: -1px;
}
.iconanniu{
  margin-left: 10px;
}
/* .box_left {
  text-align: left;
} */
/* 分页 */
.block {
  width: 1040px;
  /* margin-top: 20px; */
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  margin-bottom: 20px;
  font-size: 12px;
}
.pagingwb{
  margin-left: 24px;
}
.numberpage{
  margin-left: -30px;
}


</style>



// WEBPACK FOOTER //
// src/pages/index_new.vue